import CompanyPackagesTab from 'src/components/pages/Company/CompanyPage/CompanyPackagesTab/CompanyPackagesTab';

export default CompanyPackagesTab;
